import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { User } from '../../models/user';
import { UserBuilder } from '../../models/builders/user.builder';

const getUserBody = (user: User) => {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    reference: user.reference,
    section: user.section,
    role: user.role,
    password: user.password,
    passwordRepeat: user.passwordRepeat,
    active: user.active,
    workingShift: user.workingShift
  };

};

@Injectable()
export class UserApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }users`;
  }

  createUser(user: User) {
    return this.httpClient.post(this.apiUrl, getUserBody(user)).pipe(map(UserBuilder.fromJson));
  }

  deleteUser(user: User) {
    return this.httpClient.delete(`${ this.apiUrl }/${ user.hash }`);
  }

  getUser(hash: string) {
   return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
    .pipe(
      map(UserBuilder.fromJson)
    );
  }

  getUsers() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(UserBuilder.fromList));
  }

  updateUser(user: User) {
    return this.httpClient.put(`${ this.apiUrl }/${ user.hash }`, getUserBody(user));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/user-api.service.ts